export class LoginUserEnaio {
    groups: string[];
    personalCabinetObjectId: number;
    personInfo: { [key: string]: any };
}
